import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import Footer from "../components/Footer"
import { Container } from "react-bootstrap"
import ProfileImage from "../components/ProfileImage"
import Header from "../components/Header"
import Navbar from "../components/Navbar"
import GitCalendar from "../components/GithubCalender"
import MetaData from "../components/MetaData"
// import "../components/git-calendar.css"
// import "../../static/git-calendar"

export default function Home() {
  return (
    <div>
      <MetaData />
      <Container
        fluid
        style={{
          textAlign: "center",
        }}
      >
        {/* <Container
          style={{
            textAlign: "center",
          }}
        > */}
        <Header />

        <ProfileImage />

        <GitCalendar />

        <p
          className="text-secondary"
          style={{ fontFamily: "'Jura', sans-serif" }}
        >
          <em>
            I'm Debajit Deb, A Developer with strong passion for
            self-improvement
          </em>
        </p>

        <Navbar />
        {/* </Container> */}
        <Footer />
      </Container>
    </div>
  )
}
